// --- START OF MODIFIED FILE src/Components/Home/Trendy/Trendy.jsx ---
import React, { useState } from "react";
import "./Trendy.css"; // Uses Trendy.css
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { Link } from "react-router-dom";
import StoreData from "../../../Data/StoreData";
import { FiHeart } from "react-icons/fi";
import { FaStar, FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import { addToWishList, removeFromWishList } from "../../../Features/Wishlist/wishListSlice";

const Trendy = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("tab1");
  // const [wishList, setWishList] = useState({}); // Not used, can be removed if not needed elsewhere
  const wishlistItems = useSelector((state) => state.wishlist.items);

  const productSegments = {
    tab1: [8, 9, 10, 11, 12, 13, 14, 15],
    tab2: [29, 30, 31, 32, 33, 34, 7, 5],
    tab3: [8, 9, 25, 29, 32, 33, 34, 35],
    tab4: [6, 8, 9, 10, 25, 29, 30, 39,]
  };

  const tabNames = {
    tab1: "All",
    tab2: "New Arrivals",
    tab3: "Best Seller",
    tab4: "Top Rated"
  };

  const getSegmentProducts = () => {
    const productIds = productSegments[activeTab];
    return StoreData.filter(product => productIds.includes(product.productID));
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const isInWishlist = (productID) => {
    return wishlistItems.some(item => item.productID === productID);
  };

  const handleWishlistClick = (product) => {
    if (isInWishlist(product.productID)) {
      dispatch(removeFromWishList(product));
      toast.success('Removed from wishlist', {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    } else {
      dispatch(addToWishList(product));
      toast.success('Added to wishlist', {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const cartItems = useSelector((state) => state.cart.items);

  const isPreciousMetal = (metalType) => {
    const preciousMetals = ['Gold', 'Rose Gold', 'Platinum', 'White Gold'];
    return preciousMetals.includes(metalType);
  };

  const handleAddToCart = (product) => {
    // Check if the product is made of precious metal
    if (isPreciousMetal(product.metalType)) {
      // For mobile cart icon clicks, show warning
      toast.error("Please contact us for current pricing on precious metal items", {
        duration: 3000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
      return;
    }

    // Original cart logic for non-precious metals
    const productInCart = cartItems.find(
      (item) => item.productID === product.productID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  return (
    <>
      <div className="trendyProducts">
        <h2>
          Our Trendy <span>Products</span>
        </h2>
        <div className="trendyTabs">
          <div className="tabs">
            {Object.entries(tabNames).map(([tabKey, tabName]) => (
              <p
                key={tabKey}
                onClick={() => handleTabClick(tabKey)}
                className={activeTab === tabKey ? "active" : ""}
              >
                {tabName}
              </p>
            ))}
          </div>
          <div className="trendyTabContent">
            <div className="trendyMainContainer">
              {getSegmentProducts().map((product) => (
                <div className="trendyProductContainer" key={product.productID}>
                  <div className="trendyProductImages">
                    <Link to={`/product/${product.productID}`} onClick={scrollToTop}>
                      <img
                        src={product.frontImg}
                        alt={product.productName} // Added alt text
                        className="trendyProduct_front"
                      />
                      <img
                        src={product.backImg || product.frontImg}
                        alt={product.productName} // Added alt text
                        className="trendyProduct_back"
                      />
                    </Link>
                    {/* This is the text overlay, hidden on mobile by CSS */}
                    {isPreciousMetal(product.metalType) ? (
                      <Link to="/contact" >
                        <h4 >Contact for Price</h4>
                      </Link>
                    ) : (
                      <h4 onClick={() => handleAddToCart(product)}>
                        Add to Cart
                      </h4>
                    )}
                  </div>
                  {/* This is the icon overlay, shown on mobile by CSS. Ensure ONLY ONE and with correct class */}
                  <div
                    className="trendyProductImagesCart" // Use the class defined in Trendy.css
                    onClick={() => handleAddToCart(product)}
                  >
                    <FaCartPlus />
                  </div>
                  <div className="trendyProductInfo">
                    <div className="trendyProductCategoryWishlist">
                      <p>{product.category}</p>
                      <FiHeart
                        onClick={() => handleWishlistClick(product)}
                        style={{
                          color: isInWishlist(product.productID) ? "red" : "#767676",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <div className="trendyProductNameInfo">
                      <Link to={`/product/${product.productID}`} onClick={scrollToTop}> {/* Corrected link for product name */}
                        <h5>{product.productName}</h5>
                      </Link>
                      {isPreciousMetal(product.metalType) ? (
                        <span style={{ color: "#767676", fontWeight: "500" }}>
                          Price on inquiry
                        </span>
                      ) : (
                        <>
                          {product.isOnSale ? (
                            <>
                              <span style={{ color: "#a52a2a", fontWeight: "500" }}>
                                ${product.productPrice}
                              </span>
                               
                              <span
                                style={{
                                  color: "#767676",
                                  textDecoration: "line-through",
                                  textDecorationThickness: "1px"
                                }}
                              >
                                ${product.originalPrice}
                              </span>
                            </>
                          ) : (
                            <span style={{ color: "#767676" }}>
                              ${product.productPrice}
                            </span>
                          )}
                        </>
                      )}
                      <div className="trendyProductRatingReviews">
                        <div className="trendyProductRatingStar">
                          {[...Array(5)].map((_, index) => (
                            <FaStar
                              key={index}
                              color={index < product.stars ? "#FEC78A" : "#C4C4C4"}
                              size={10}
                            />
                          ))}
                        </div>
                        <span>{product.productReviews}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="discoverMore">
          <Link to="/shop" onClick={scrollToTop}>
            <p>Discover More</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Trendy;
// --- END OF MODIFIED FILE src/Components/Home/Trendy/Trendy.jsx ---